export const HOME_PAGE_SEARCH_INPUT_ID = 'my-search';

export const HEADER_ID = 'website-header';

export const HEADER_SEARCH_INPUT_ID = 'my-search-header';

export const JOB_TITLE_PAGE_SEARCH_INPUT_ID = 'job-title-search';

export const JOB_TITLE_PAGE_CITY_SEARCH_ID = 'job-title-city-search';

export const JOB_TITLE_PAGE_SUBSCRIBE_CITY_SEARCH_ID =
  'job-title-subscribe-city-search';

export const CULTURAL_QUIZ_ID = 'quiz';

export const RESUME_CONSULT_SERVICE_ID = 'resume_consult-srvice';

export const RESUME_IFRAME_ID = 'resume-iframe';

export const JOB_TITLE_PAGE_SUBSCRIBE1 = 'job_title_page-subscribe1';

export const JOB_TITLE_PAGE_SUBSCRIBE2 = 'job_title_page-subscribe2';

export const HOME_PAGE_RESUME_CONSULT = 'home_page-resume-consult';

export const RESUME_DASHBOARD_NAV_ID = 'resume-dashboard-nav';

export const NOT_FOUND_PAGE_ID = 'not-found';

export const LOGIN_CODE_CAPTCHA_ID = 'login-code-captcha';

export const LOGIN_CODE_CAPTCHA_CLICK_ID = 'login-code-captcha-click';

export const HOME_PAGE_RESUME_EVALUATION_ID = 'home_page-resume-evaluation';

export const EVALUATION_PAYMENT_ID = 'evaluation_payment';

export const EVALUATION_INTRO_ID = 'evaluation_intro';
